import axios from "./axios";

export default {
    getAppointmentsOfMedicalForms() {
        const options = {
            method: 'GET',
            url: `medicalcalendar/getAppointmentsOfMedicalForms`,
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getPatient(params) {
        const options = {
            method: 'GET',
            url: `medicalcalendar/getPatient`,
            headers: { 'content-type': 'application/json' },
            params: params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.messageage)
                })
        })
    },

    getCustomer() {
        const options = {
            method: 'GET',
            url: `medicalcalendar/getCustomer`,
            headers: { 'content-type': 'application/json' }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    postAddAppointment(data) {
        const options = {
            method: 'POST',
            url: `medicalcalendar/postAddAppointment`,
            headers: { 'content-type': 'application/json' },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    postDelAppointment(data) {
        const options = {
            method: 'POST',
            url: `medicalcalendar/postDelAppointment`,
            headers: { 'content-type': 'application/json' },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.messageageageage)
                })
        })
    }

}